<template>
  <v-app>
    <div v-if="initialApiError" class="pa-4 initial-api-error">
      <v-alert
        type="error"
        variant="tonal"
        border="start"
        density="comfortable"
        icon="mdi-alert"
        closable
        @click:close="dismissInitialApiError"
      >
        {{ initialApiError }}
        <div v-if="showAuthSignOut" class="mt-2">
          <v-btn size="small" variant="outlined" @click="signOutFromError">
            {{ $t("auth.signOut") }}
          </v-btn>
        </div>
      </v-alert>
    </div>
    <router-view></router-view>
  </v-app>
</template>

<script>
import { appendLangParam } from "@/i18n";
import axios from "axios";
import { ISI_API_URL, CURRENT_ENV } from "./config";
import * as Chartist from "chartist";

export default {
  data() {
    return {
      user_data: { first_name: "Bob", is_admin: false },
      auth_response: {},
      Chartist: Chartist,
      initialApiError: "",
      showAuthSignOut: false,
    };
  },
  methods: {
    dismissInitialApiError() {
      this.initialApiError = "";
    },
    authErrorMessage(code) {
      if (code === "account_not_provisioned") {
        return this.$t("auth.accountNotProvisioned");
      }
      if (code === "account_suspended") {
        return this.$t("auth.accountSuspended");
      }
      if (code === "identity_mismatch") {
        return this.$t("auth.identityMismatch");
      }
      if (code) {
        return this.$t("auth.signInFailedCode", { code });
      }
      return this.$t("auth.signInFailed");
    },
    signOutFromError() {
      axios
        .get(ISI_API_URL + "logout", { withCredentials: true })
        .then(function (resp) {
          if (resp.data && resp.data.login_url) {
            window.location.href = appendLangParam(resp.data.login_url);
          } else {
            window.location.reload();
          }
        })
        .catch(function () {
          window.location.reload();
        });
    },
    get_user_data: function () {
      var vm = this;
      const final_url =
        window.location.origin +
        window.location.pathname +
        window.location.search;

      console.log("Auth Debug Info:");
      console.log("- Current Environment:", CURRENT_ENV);
      console.log("- API URL:", ISI_API_URL);
      console.log("- Final URL:", final_url);
      console.log("- Hostname:", window.location.hostname);

      axios
        .get(ISI_API_URL + "user", {
          params: {
            final_url: final_url,
            requested_resource: "isivideo/testloop",
            product_id: "none",
          },
          withCredentials: true,
        })
        .then(function (data) {
          console.log("Auth Success:", data.data);
          vm.$store.commit("update_user_data", data.data);
          vm.user_data = data.data;
          vm.auth_response = data;
          // Mark auth as initialized
          vm.$store.commit("set_auth_initialized", true);
        })
        .catch(function (err) {
          console.error("Auth Error:", err);
          // Mark auth as initialized even on error
          vm.$store.commit("set_auth_initialized", true);

          if (err.response && err.response.data) {
            console.error("Login URL:", err.response.data.login_url);
            console.error("Error Details:", err.response.data);

            if (typeof err.response.data.login_url != "undefined") {
              // Add a small delay to ensure console logs are visible
              setTimeout(() => {
                window.location.href = appendLangParam(
                  err.response.data.login_url,
                );
              }, 100);
            } else {
              // Authenticated at the IdP but rejected by isi_data
              // (account_not_provisioned / account_suspended /
              // identity_mismatch) — without a message the user just
              // sees a dead console. Offer sign-out to escape the
              // Kratos session and try another account.
              vm.initialApiError = vm.authErrorMessage(err.response.data.error);
              vm.showAuthSignOut = true;
            }
          } else {
            console.error("Network error or API unavailable");
            vm.initialApiError = vm.$t("auth.apiUnavailable");
          }
        });
    },
  },
  created: function () {
    this.get_user_data();
  },
};
</script>

<style scoped>
.initial-api-error {
  position: fixed;
  top: 220px;
  left: 50%;
  transform: translateX(-50%);
  width: min(90vw, 720px);
  z-index: 4000;
}
</style>
